import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import * as constants from './constants'

const AccountStatementModal = Loadable(() => import('./AccountStatementModal'))

export default Loadable(() => import('./AccountStatement'))

export { constants, AccountStatementModal }
